import { AuthRepository } from "../api";

export default class ResetPasswordMiddleware {
    async validate(nextState, replace, cb) {
        const { token } = nextState.location.query;

        if(!token) {
            replace("/");
            return cb();
        }

        const authRepo = new AuthRepository();
        const response = await authRepo.validateResetPasswordToken(token);

        if(response.error) {
            replace("/");
        }

        return cb();
    }
}


// WEBPACK FOOTER //
// src/middlewares/ResetPasswordMiddleware.js